import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  // Close on ESC key
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  return <AnimatePresence data-id="element-222">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-stone-900/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" aria-hidden="true" data-id="element-223" />

          {/* Modal Card */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        duration: 0.5
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-224">
            <div className="bg-[#FFF9E6] w-full max-w-2xl max-h-[85vh] rounded-2xl shadow-2xl border border-orange-100 flex flex-col pointer-events-auto overflow-hidden" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-225">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-orange-200/50 bg-white/50" data-id="element-226">
                <h2 id="modal-title" className="text-2xl font-bold text-stone-800" data-id="element-227">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 rounded-full hover:bg-amber-100 text-stone-500 hover:text-amber-700 transition-colors" aria-label="Cerrar" data-id="element-228">
                  <X className="w-6 h-6" data-id="element-229" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto custom-scrollbar text-stone-600 leading-relaxed space-y-4" data-id="element-230">
                {children}
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}